module.exports = __webpack_public_path__ + "static/media/approved-table.8333797d.svg";